import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, X, Plus, Minus } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import './CartDrawer.css';

const CartDrawer = () => {
  const { cartItems, isCartOpen, closeCart, removeFromCart, updateQuantity, getTotalPrice, getTotalItems } = useCart();
  const [promoCode, setPromoCode] = useState('');

  const subtotal = getTotalPrice();
  const shipping = subtotal >= 49 ? 0 : 8.95;
  const total = subtotal + shipping;
  const totalItems = getTotalItems();
  const navigate = useNavigate();

  return (
    <>
      <div className={`cart-drawer-overlay ${isCartOpen ? 'open' : ''}`} onClick={closeCart} />
        <div className={`cart-drawer ${isCartOpen ? 'open' : ''}`}>
        <div className="cart-drawer-header">
          <h2 className="cart-drawer-title">Shopping Bag ({totalItems})</h2>
          <button className="cart-drawer-close" onClick={closeCart}><X size={24} /></button>
        </div>

        {cartItems.length === 0 ? (
          <div className="cart-drawer-items">
            <div className="cart-drawer-empty">
              <ShoppingBag className="cart-drawer-empty-icon" />
              <h3 className="cart-drawer-empty-title">Your bag is empty</h3>
              <p className="cart-drawer-empty-text">Looks like you haven't added anything yet.</p>
              <Link to="/shop" className="cart-drawer-empty-cta" onClick={closeCart}>Start Shopping</Link>
            </div>
          </div>
        ) : (
          <>
            <div className="cart-drawer-items">
              {cartItems.map((item) => (
                <div key={`${item.product.id}-${item.selectedSize}-${item.selectedColor.name}`} className="cart-item">
                  <img src={item.product.image} alt={item.product.name} className="cart-item-image" />
                  <div className="cart-item-details">
                    <p className="cart-item-brand">{item.product.brand}</p>
                    <h4 className="cart-item-name">{item.product.name}</h4>
                    <p className="cart-item-options">Size: {item.selectedSize} | Color: {item.selectedColor.name}</p>
                    <div className="cart-item-pricing">
                      <span className="cart-item-price">${(item.product.salePrice || item.product.price).toFixed(2)}</span>
                    </div>
                    <div className="cart-item-quantity">
                      <button className="cart-item-quantity-btn" onClick={() => updateQuantity(item.product.id, item.selectedSize, item.selectedColor.name, item.quantity - 1)}><Minus size={14} /></button>
                      <span className="cart-item-quantity-value">{item.quantity}</span>
                      <button className="cart-item-quantity-btn" onClick={() => updateQuantity(item.product.id, item.selectedSize, item.selectedColor.name, item.quantity + 1)}><Plus size={14} /></button>
                      <button className="cart-item-remove" onClick={() => removeFromCart(item.product.id, item.selectedSize, item.selectedColor.name)}>Remove</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-drawer-promo">
              <form className="cart-drawer-promo-form" onSubmit={(e) => { e.preventDefault(); setPromoCode(''); }}>
                <input type="text" placeholder="Enter promo code" className="cart-drawer-promo-input" value={promoCode} onChange={(e) => setPromoCode(e.target.value)} />
                <button type="submit" className="cart-drawer-promo-btn">Apply</button>
              </form>
            </div>

            <div className="cart-drawer-footer">
              <div className="cart-drawer-summary">
                <div className="cart-drawer-summary-row"><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
                <div className="cart-drawer-summary-row"><span>Shipping</span><span>{shipping === 0 ? 'FREE' : `$${shipping.toFixed(2)}`}</span></div>
                <div className="cart-drawer-summary-row total"><span>Total</span><span>${total.toFixed(2)}</span></div>
              </div>
              <button className="cart-drawer-checkout" onClick={() => { closeCart(); navigate('/checkout'); }}>
                Proceed to Checkout
              </button>
              <Link to="/shop" className="cart-drawer-continue" onClick={closeCart}>Continue Shopping</Link>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CartDrawer;
